import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import FlaggedModal from "./FlaggedModal";
import ConfirmUnflag from "./FlaggedModal/ConfirmUnflag";
import MoveToTrash from "./TrashModals/MoveToTrash";
import PermanentDelete from "./TrashModals/PermanentDelete";
import UnFavoriteConfirmModal from "./FavoritesModals/UnFavoriteConfirmModal";
import UnFavoriteModal from "./FavoritesModals/unFavoriteModal";
import VideoMoveToTrash from "./VideoTrashModals/VideoMoveToTrash";
import VideoConfirmRestore from "./VideoTrashModals/VideoConfirmRestore";
import VideoConfirmDelete from "./VideoTrashModals/VideoConfirmDelete";
import RestoreFromTrash from "./TrashModals/RestoreFromTrash";
import FirstVideoStep1 from "../Tutorials/FirstVideo/FirstVideoStep1";
import FirstVideoStep2 from "../Tutorials/FirstVideo/FirstVideoStep2";
import FirstVideoAnalyzedStep1 from "../Tutorials/FirstVideo/FirstVideoAnalyzedStep1";
import { updateTutorialState } from "../Tutorials/TutorialActions";
import { getSingleVideoDetails } from "../../Pages/Home/home_actions";
import VideoTranscriptModal from "./VideoTranscriptModal/VideoTranscriptModal";
import ProcessConfirmation from "./ProcessConfirmation/ProcessConfirmation";
import { updateAskVyrillIntroModal } from "./Actions";

const ModalsIndex = () => {
  const dispatch = useDispatch();
  const videoCount = useSelector(
    (state) => state.navbarStatsReducer.counts.videos
  );

  useEffect(() => {
    let timerId;

    if (
      videoCount == 1 &&
      localStorage.getItem("firstVideoAnalysisId")?.split(",")[1] == "pending"
    ) {
      timerId = setInterval(() => {
        callAPI();
      }, 5 * 60 * 1000);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [videoCount]);

  const callAPI = () => {
    getSingleVideoDetails(
      localStorage.getItem("firstVideoAnalysisId").split(",")[0]
    )
      .then((videoResponse) => {
        if (videoResponse?.video?.analysis_stage === "completed") {
          const updateValue = localStorage
            .getItem("firstVideoAnalysisId")
            .replace("pending", "completed");

          localStorage.setItem("firstVideoAnalysisId", updateValue);

          dispatch(
            updateTutorialState({
              isTutorial: true,
              activeTutorial: "first-video-analyzed",
              activeStep: 1,
              totalSteps: 2,
            })
          );
        } else {
        }
      })
      .catch((err) => {
        console.log(err);
        // Handle the error case here
      });
  };

  return (
    <>
      {/* Video Trash Feature Modal  @TODO Products*/}
      <MoveToTrash />
      <PermanentDelete />
      <VideoConfirmRestore />
      <VideoConfirmDelete />
      <RestoreFromTrash />

      {/* Video Flag feature modal */}
      <FlaggedModal />
      <ConfirmUnflag />

      {/* Video Favorite feature modal */}
      <UnFavoriteConfirmModal />

      {/* @TODO Reuse for videos */}
      <UnFavoriteModal />

      {/* Video Tutorials */}
      <FirstVideoStep1 />
      <FirstVideoStep2 />
      <VideoMoveToTrash />
      <FirstVideoAnalyzedStep1 />
      <VideoTranscriptModal />
      <ProcessConfirmation />
    </>
  );
};

export default ModalsIndex;
